class ProductSubscription extends HTMLElement {
  constructor() {
    super();

    this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
    this.oneTimePrice =
      this.querySelector(".js-one-time-label").querySelector(".price");

    if (this.closest("product-info")) {
      this.productPrice = this.closest("product-info").querySelector(
        ".product__buy-area .price"
      );
    } else if (this.closest("product-card")) {
      this.productPrice = this.closest("product-card").querySelector(
        ".card__content-lower .price"
      );
    }

    this.subscriptionPrice = this.querySelector(".js-subscription-price");
    this.subscriptionPriceValue = this.querySelector("#selling-plan-price");

    this.subscribeRadios = this.querySelectorAll(".js-selling-plan-radio");
    this.selectedSubscribeRadio = this.querySelector(
      ".js-selling-plan-radio:checked"
    );

    this.subscribeRadios.forEach((radioItem) => {
      radioItem.addEventListener("change", () => {
        this.selectedSubscribeRadio = radioItem;
        this.handleSubscribeChange();
      });
    });

    this.sellingPlanSelect = this.querySelector("#selling-plan-id");
    this.sellingPlanSelect.addEventListener("change", () => {
      this.subscriptionPriceValue = this.querySelector("#selling-plan-price");
      this.sellingPlanSelect = this.querySelector("#selling-plan-id");
      if (this.selectedSubscribeRadio.value === "subscribe") {
        this.sellingPlanInput.value = this.sellingPlanSelect.value;
        this.subscriptionPriceValue.innerHTML = this.sellingPlanSelect
          .querySelector("option[value='" + this.sellingPlanSelect.value + "']")
          .getAttribute("data-price");
        this.handleSubscribeChange();
      }
    });
  }

  handleSubscribeChange() {
    if (this.closest("product-info")) {
      this.productPrice = this.closest("product-info").querySelector(
        ".product__buy-area .price"
      );
    } else if (this.closest("product-card")) {
      this.productPrice = this.closest("product-card").querySelector(
        ".card__content-lower .price"
      );
    }

    if (this.selectedSubscribeRadio.value === "subscribe") {
      if (
        this.productPrice &&
        this.subscriptionPriceValue &&
        this.productPrice.classList.contains("price--on-sale")
      ) {
        this.productPrice.querySelector(
          ".price__sale .price-item--sale"
        ).innerHTML = this.subscriptionPriceValue.innerHTML;
      } else if (this.productPrice && this.subscriptionPrice) {
        this.productPrice.classList = this.subscriptionPrice.classList;
        this.productPrice.innerHTML = this.subscriptionPrice.innerHTML;
      }

      this.sellingPlanInput.value = this.sellingPlanSelect.value; //get sellingplan id from select dropdown
    } else {
      if (this.oneTimePrice && this.productPrice) {
        this.productPrice.classList = this.oneTimePrice.classList;
        this.productPrice.innerHTML = this.oneTimePrice.innerHTML;
      }
      this.sellingPlanInput.value = ""; //reset selling plan id
    }

    if (this.closest("product-info")) {
      this.closest("product-info").dispatchEvent(new Event("update-loyalty"));
    }
  }
}
customElements.define("product-subscription", ProductSubscription);
